function parseBoolean(value: unknown): boolean {
  return value === true || value === 'true' || value === '1';
}

function isLocalRuntime(): boolean {
  if (typeof window === 'undefined') return false;
  const hostname = window.location.hostname;
  return hostname === 'localhost' || hostname === '127.0.0.1';
}

const IS_DEV = import.meta.env.DEV || isLocalRuntime();

function getQueryFlag(name: string): boolean | null {
  if (typeof window === 'undefined') return null;
  const value = new URLSearchParams(window.location.search).get(name);
  if (value == null) return null;
  return parseBoolean(value);
}

export const DEV_FLAGS = {
  cosmeticsGallery: IS_DEV && parseBoolean(import.meta.env.VITE_DEV_COSMETICS_GALLERY ?? 'true'),
  testMatch: IS_DEV && parseBoolean(import.meta.env.VITE_DEV_TEST_MATCH ?? 'false'),
  unlockAllCosmetics: IS_DEV && (getQueryFlag('unlockAllCosmetics')
    ?? (isLocalRuntime()
      ? true
      : parseBoolean(import.meta.env.VITE_DEV_UNLOCK_ALL_COSMETICS ?? 'false'))),
  disableRewards: IS_DEV && parseBoolean(import.meta.env.VITE_DEV_DISABLE_REWARDS ?? 'false'),
};

export function isDevRoute(pathname: string): boolean {
  return pathname === '/dev/cosmetics' && DEV_FLAGS.cosmeticsGallery;
}
